import React from 'react';
import proptypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';

const { string, shape, number } = proptypes;

const StoreInfo = ({ store, id }) => {
  const {
    storeName,
    url,
    phone,
    rentalsLink,
    servicesLink,
    address
  } = store;

  const gardenLink = servicesLink.replace('services', 'garden-center');
  const proDeskLink = servicesLink.replace('services', 'pro-desk');
  const addressJoined = `${address.city}, ${address.state} ${address.postalCode}`;
  const rentalsLinkName = `${storeName} Rentals`;
  const servicesLinkName = `${storeName} Home Services`;
  const gardenLinkName = `${storeName} Garden Center`;
  const proDeskLinkName = `${storeName} Pro Desk`;

  return (
    <div className="sui-list-none sui-pb-2 sui-inline-block">
      <Link
        underline="none"
        id={`${storeName}-${id}`}
        href={url}
      >
        {storeName}
      </Link>

      <ul className="sui-list-none sui-min-w-36">
        <li>{address.street}</li>
        <li>{addressJoined}</li>
        <li>{phone}</li>
        <li>
          <Link
            underline="none"
            id={`${storeName}Rentals-${id}`}
            href={rentalsLink}
          >
            {rentalsLinkName}
          </Link>
        </li>
        <li>
          <Link
            underline="none"
            id={`${storeName}HomeServices-${id}`}
            href={servicesLink}
          >
            {servicesLinkName}
          </Link>
        </li>
        <li>
          <Link
            underline="none"
            id={`${storeName}GardenCenter-${id}`}
            href={gardenLink}
          >
            {gardenLinkName}
          </Link>
        </li>
        <li>
          <Link
            underline="none"
            id={`${storeName}ProDesk-${id}`}
            href={proDeskLink}
          >
            {proDeskLinkName}
          </Link>
        </li>
      </ul>
    </div>
  );
};

StoreInfo.propTypes = {
  store: shape({
    storeName: string.isRequired,
    url: string.isRequired,
    phone: string.isRequired,
    rentalsLink: string.isRequired,
    servicesLink: string.isRequired,
    address: shape({
      city: string,
      county: string,
      postalCode: string,
      state: string,
      street: string,
    }).isRequired
  }).isRequired,
  id: number.isRequired
};

StoreInfo.displayName = 'StoreInfo';

export { StoreInfo };
